import { ExtendedCarItemType } from '@/interfaces/cars.interfaces';

/**
 * Возвращает форматированную строку местоположения автомобиля.
 * @example "Московская область, Москва, Диллернейм"
 *
 * @param extendedData объект автомобиля, используется для поиска данных по местоположению.
 * @param locationIds Массив collection_id относительно которых будет собираться информация по местоположению.
 * @returns
 */
const getCarLocation = (
  extendedData: ExtendedCarItemType,
  locationIds: Array<string>,
): string => {
  const locationString = locationIds.reduce((acc, locationId) => {
    const location = extendedData.data.locations?.find(
      loc => loc.collection_id === locationId,
    );

    if (location?.displayName) {
      return `${acc}${location.displayName}, `;
    }

    return acc;
  }, '');

  return locationString ? locationString.slice(0, -2) : locationString;
};

export default getCarLocation;
